var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-center-login"},[_c('content-loader',{attrs:{"loading":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }